import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { UserService } from 'services/user/user.service';

export const userKeys = {
  all: ['users'] as const,
  create: () => [...userKeys.all, 'create'] as const,
  update: () => [...userKeys.all, 'update'] as const,
  delete: () => [...userKeys.all, 'delete'] as const,
};

// Hook to fetch organizations list
export const useCreateUser = () => {
  const client = useQueryClient();
  return useMutation({
    mutationFn: async ({ userData }: { userData: any }) => {
      try {
        const result = await UserService.createUser(userData);
        return result;
      } catch (error) {
        console.error('Mutation API call failed:', error);
        throw error;
      }
    },
    onSuccess: (_, { userData }) => {
      console.log('Mutation onSuccess called, invalidating queries for userData:', userData);
      client.invalidateQueries({ queryKey: userKeys.create() });
      client.invalidateQueries({ queryKey: userKeys.all });
    },
  });
};

// Hook to update user
export const useUpdateUser = () => {
  const client = useQueryClient();
  return useMutation({
    mutationFn: async ({ userId, userData }: { userId: string; userData: any }) => {
      try {
        const result = await UserService.editUser(userId, userData);
        return result;
      } catch (error) {
        console.error('Mutation API call failed:', error);
        throw error;
      }
    },
    onSuccess: (_, { userId }) => {
      console.log('Mutation onSuccess called, invalidating queries for userId:', userId);
      client.invalidateQueries({ queryKey: userKeys.update() });
      client.invalidateQueries({ queryKey: userKeys.all });
    },
  });
};
// Hook to delete user
export const useDeleteUser = () => {
  const client = useQueryClient();
  return useMutation({
    mutationFn: async ({ userId }: { userId: string }) => {
      try {
        const result = await UserService.deleteUser(userId);
        return result;
      } catch (error) {
        console.error('Mutation API call failed:', error);
        throw error;
      }
    },
    onSuccess: (_, { userId }) => {
      console.log('Mutation onSuccess called, invalidating queries for userId:', userId);
      client.invalidateQueries({ queryKey: userKeys.delete() });
      client.invalidateQueries({ queryKey: userKeys.all });
    },
  });
};

export const useListUsers = () => {
  return useQuery({
    queryKey: userKeys.all,
    queryFn: () => UserService.getListUsers(),
  });
};
